import React from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { Layout } from 'antd';
import ThemeContext from './Theme';
import { InfoUsuario } from '@utils';
import Header from './Header';
import Footer from './Footer';
import Sider from './Sider';

const Container = styled(Layout)`
  height: stretch;
`;

const Content = styled(Layout)`
  background-color: #fff;
`;

const Body = styled(Layout.Content)`
  display: flex;
  flex-direction: column;
`;

const Children = styled.div`
  flex: 1 1 auto;
  display: flex;
`;

const App = ({ children, siderProps }) => {
  const infoUsuario = InfoUsuario.get();
  const theme = useSelector(({ theme }) => theme.get('theme'));

  return(
    <ThemeContext.Provider value={theme}>
      <Container>
        <Header infoUsuario={infoUsuario} />
        <Content>
          <Sider siderProps={siderProps} infoUsuario={infoUsuario} />
          <Body>
            <Children>
              {children}
            </Children>
            <Footer />
          </Body>
        </Content>
      </Container>
    </ThemeContext.Provider>
  );
};

export default App;
